var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lead-Detail_Activity_V3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.411,
    height: 20.377,
    viewBox: "0 0 10.411 20.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lead-Detail-Page-_Basic-Details-_v3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title-Header",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-information",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "designation",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_tie",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M2.646,15.618a1.1,1.1,0,0,1-.279-1.074l.979-4.425a1.015,1.015,0,0,1,1.052-.7H6.012a1.017,1.017,0,0,1,1.053.7l.978,4.472a1.053,1.053,0,0,1-.278,1.051L5.981,17.416a1.1,1.1,0,0,1-1.55-.012Zm.926-8.391A2.108,2.108,0,0,0,1.467,8.722L.085,14.608a2.146,2.146,0,0,0,.557,2.127l3.015,3a2.192,2.192,0,0,0,3.1-.006L9.77,16.714a2.193,2.193,0,0,0,.557-2.152L8.945,8.722A2.11,2.11,0,0,0,6.839,7.227ZM5.708,4.38h-1a1.1,1.1,0,1,1,0-2.19h1a1.1,1.1,0,0,1,0,2.19ZM9.161,2.55A2.19,2.19,0,0,0,7,0H3.41A2.191,2.191,0,0,0,1.25,2.55l.366,2.19A2.189,2.189,0,0,0,3.775,6.57h2.86A2.191,2.191,0,0,0,8.8,4.741Z",
    transform: "translate(0 0)",
    fill: "#bcbcbc",
    fillRule: "evenodd"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignation);
export default __webpack_public_path__ + "static/media/designation.1f295c9721693a2ce83e1fac4c528a17.svg";
export { ForwardRef as ReactComponent };